<template>
	<div id="cloudCenter">
		<heads></heads>
		<div class="video_left">
			<div class="pro_video">
				<div class="project_title">
					<div class="pro_name">设备位置</div>

				</div>
				<div class="pro_video_box">
				<el-tree
					class='videotree'
				  :props="props"
				  :load="loadNode"
					node-key="id"
					:default-expanded-keys="[initialId]"
				  lazy
				  @node-click="nodeClick"
				  >
				</el-tree>
				</div>
			</div>
			<div class="lately_box">
					<div class="kz_box">
						{{kzName}}
					</div>
					<div class="fpxz_box">
						<el-tooltip class="item" effect="dark"  content="全屏" placement="top">
							<img src="../../assets/screen1.png" @click="changeVideo(1)"  />
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="四分屏" placement="top">
							<img src="../../assets/screen4.png" @click="changeVideo(4)" />
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="九分屏" placement="top">
							<img src="../../assets/screen9.png" @click="changeVideo(9)"/>
						</el-tooltip>
					</div>
					<div class="sxzy_box">
						<img class="img_left" @mousedown='control("left")' @mouseup='control("stop")' src="../../assets/video_left.png"/>
						<img class="img_right" @mousedown='control("right")' @mouseup='control("stop")' src="../../assets/video_right.png"/>
						<img class="img_center" @mousedown='control("stop")' @mouseup='control("stop")' src="../../assets/center_stop.png"/>
						<img class="img_top" @mousedown='control("up")' @mouseup='control("stop")' src="../../assets/video_top.png"/>
						<img class="img_bottom" @mousedown='control("down")' @mouseup='control("stop")' src="../../assets/video_bottom.png"/>
					</div>
					<div class="max_min">
						<div @mousedown='control("zoomin")' @mouseup='control("stop")'><img src="../../assets/screen_max.png"/>放大</div>
						<div @mousedown='control("zoomout")' @mouseup='control("stop")'><img src="../../assets/screen_min.png"/>缩小</div>
					</div>
					<div class="slider_box">
						<el-tooltip class="item" effect="dark" content="旋转速度" placement="top">
							<el-slider v-model="sliderVidewo" :min="30" :max="250"></el-slider>
						</el-tooltip>
					</div>
			</div>
		</div>
		<div class="video_right" v-loading="fullscreenLoading" element-loading-text="切换中"  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 1)">
			<div class="vide_box" v-for="(item,index) in num" :class="clickIndex==index?'clickActive':''" :style="{width:widthHeight,height:widthHeight}">
				<span @click="seleClick(index)"> </span>
				<div :id="'myPlayer'+index"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import EZUIKit from '@/assets/js/EZUIKitPlayer.js';
	import heads from "@/components/header.vue"
	export default {
		data() {
			return {
				colorlists: [],
				prolist: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, ],
				projectLists: [],
				RecentAccess: [],
				projectNamekeyword: '',
				player: [],
				videoUrl: [],
				num: 9,
				activeNum:4,
				widthHeight: "33.33%",
				videoToken:'',
				selected:false,
				videoIndex: 0,
				nameIndex:null,
				clickIndex:0,
				record:[],
				sliderVidewo:150,
				kzName:'',
				arrList:[],//储存搜索
				replayCount:{},//重新播放计数，十五次失败时候不再重新播放
				fullscreenLoading:false,
				playindex:0,
				allIndex:0,
				njorjg:true,
				props: {
		          label: 'label',
		          children: 'hasChildren',
		          isLeaf: 'leaf'
		        },
		        initialId:''
			}
		},
		components: {
			heads,
		},
		watch: {
	        videopalyer (data) {
	        	this.getlist()
	        },
	   },
		created() {
			let that=this
			this.postAxios('/build/ysy/getAccessToken',{},'json').then(res => {//获取视频播放token
				this.videoToken=res.data.data.accessToken
			}).catch(err => {})

		},
		mounted() {
			this.resetScreenSize();
			let that=this;
			window.addEventListener('message',function(e){
				if(e.data.type==='handleError'){
					setTimeout(function(){
						let domNodeId=e.data.id;
						console.log("时间到，开始执行",new Date().toString)
						let index=	domNodeId.substring(domNodeId.length-1, domNodeId.length)
						if(that.replayCount[domNodeId]!=null&&that.replayCount[domNodeId]!=undefined){
							that.replayCount[domNodeId]=that.replayCount[domNodeId]+1;
							if(that.replayCount[domNodeId]>that.playerNum){
									return;
							}
						}else{
							that.replayCount[domNodeId]=1;
						}
						console.log(domNodeId+"播放失败，第 "+that.replayCount[domNodeId]+" 次重试")
						that.player[index].play().then( e=>{
							console.log("重播成功")
						});
					},180000)

				}
			});
		},
		methods: {
			nodeClick(node){
				if(node.url){
					this.nameClick(node)
				}
			},
			 loadNode(node, resolve) {
			 	let that=this
		        if (node.level === 0) {
		        	this.postAxios('/build/equipmentLocation/queryTreeListByParentId/0', {}, 'json').then(res => {
						this.projectLists=[]
						this.projectLists = res.data.data
						this.initialId=res.data.data[0].id
						this.getVideo(this.initialId)
						return resolve(res.data.data);
					}).catch(err => {})
		        }else if (node.level > 0){
		        	if(node.data.hasChildren>0){
		        		this.postAxios('/build/equipmentLocation/queryTreeListByParentId/'+node.data.id, {}, 'json').then(res => {

							return resolve(res.data.data);
						}).catch(err => {})
		        	}else{
		        		this.postAxios('/build/equipmentAssets/list', {
		        			locationId:node.data.id,
		        			pageType:0
		        		}, 'json').then(res => {
		        			let data=res.data.data.list
		        			for(let i=0 ;i<data.length;i++){
		        				data[i].label=data[i].assetName
		        				data[i].leaf=true
		        			}
							return resolve(data);
						}).catch(err => {})
		        	}
		        }
		      },
		      getVideo(id){//初始化播放
				this.postAxios('/build/equipmentAssets/list', {
					locationId:id,
					pageType:0
				}, 'json').then(res => {
					let dataList=res.data.data.list
					for(let i=0;i<dataList.length;i++){
						if(dataList[i].url){
							this.nameClick(dataList[i])
						}
					}
				}).catch(err => {})
			},
			getlist(){
				this.postAxios('/build/equipmentLocation/queryTreeListByParentId/0', {}, 'json').then(res => {
					this.projectLists=[]
					this.projectLists = res.data.data

				}).catch(err => {})
			},

			search(){
				let arr=[]
				this.nameIndex=null
				for(let i=0;i<this.arrList.length;i++){
					if(this.arrList[i].projectAbbreviation.indexOf(this.projectNamekeyword)!=-1){
						arr.push(this.arrList[i])
					}
				}
				this.projectLists=arr
			},
			videoStop2() {
				let that=this
				let index=0
				let all=this.player.length
				return new Promise((resolve) => {
					for(let i = this.player.length - 1; i >= 0; i--) {
						that.player[i].stop().then(() => {
						that.player[i].destroy().then(() => {
							setTimeout(function(){
								index++
							},i*100)
						})
					}).catch(()=>{
					})
					}
					countIndex()
					function countIndex(){
				      setTimeout(function() {
				  if(index < all){
				        countIndex()
				  }else {
				  	that.player=[]
				        resolve()
				  }
				      }, 1000);
				}
				});
			},
			async changeVideo(index){
				this.activeNum=index
				if(index == this.num) {
					return
				}
				 this.fullscreenLoading = true;
				this.replayCount={};
				if(index == 1) {
					this.widthHeight = '100%'
					if(this.player.length > 0) {
						let videoArr=[]
						for(let i=0;i<this.player.length;i++){
							videoArr.push(this.player[i].opt.url)
						}
						await this.videoStop2()
						this.num = index
						let arrLength
						if(videoArr.length>index){
							arrLength=index
						}else{
							arrLength=videoArr.length
						}
						for(let i=0;i<arrLength;i++){
							this.player.push(
								new EZUIKit.EZUIKitPlayer({
									id: 'myPlayer' +i, // 视频容器ID
									accessToken: this.videoToken, //授权过程获取的access_token
									url: videoArr[i],
									// audio: 1,//是否默认开启声音 1：打开（默认） 0：关闭
									template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
								})
							)
						}
						this.fullscreenLoading=false
					}else{
						this.num = index
						this.fullscreenLoading=false
					}
				} else if(index == 4) {
					this.widthHeight = '50%'
					if(this.player.length > 0) {
						let videoArr=[]
						for(let i=0;i<this.player.length;i++){
							videoArr.push(this.player[i].opt.url)
						}
						await this.videoStop2()
						this.num = index
						let arrLength
						if(videoArr.length>index){
							arrLength=index
						}else{
							arrLength=videoArr.length
						}
						let that=this;
						for(let i=0;i<arrLength;i++){
							this.player.push(
								new EZUIKit.EZUIKitPlayer({
									id: 'myPlayer' +i, // 视频容器ID
									accessToken: this.videoToken, //授权过程获取的access_token
									url: videoArr[i],
									// audio: 1,//是否默认开启声音 1：打开（默认） 0：关闭
									template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
								})
							)
						}
						this.fullscreenLoading=false
					}else{
						this.num = index
						this.fullscreenLoading=false
					}

				} else if(index == 9) {
					this.widthHeight = '33.33%'
					if(this.player.length > 0) {
						let videoArr=[]
						for(let i=0;i<this.player.length;i++){
							videoArr.push(this.player[i].opt.url)
						}
						await this.videoStop2()
						this.num = index
						let arrLength
						if(videoArr.length>index){
							arrLength=index
						}else{
							arrLength=videoArr.length
						}
						for(let i=0;i<arrLength;i++){
							this.player.push(
								new EZUIKit.EZUIKitPlayer({
									id: 'myPlayer' +i, // 视频容器ID
									accessToken: this.videoToken, //授权过程获取的access_token
									url: videoArr[i],
									// audio: 1,//是否默认开启声音 1：打开（默认） 0：关闭
									template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
								})
							)
						}
						this.fullscreenLoading=false
					}else{
						this.num = index
						this.fullscreenLoading=false
					}
				}
			},
			seleClick(index){
				this.clickIndex=index
				this.selected=true
				this.kzName=this.record!=undefined&&this.record[this.clickIndex]!=undefined&&this.record[this.clickIndex].assetName!=undefined?this.record[this.clickIndex].assetName:"";
			},
			control(type){//按下
				if(this.record[this.clickIndex]){
					this.postAxios('/build/ysy/ptzControl',{
						deviceId:this.record[this.clickIndex].deviceChannelId,
						channelId:this.record[this.clickIndex].deviceChannelId,
						type:type,
						speed:this.sliderVidewo
					},'json').then(res => {
						if(res.data.code==412&&type=='stop'){
							this.$message.error(res.data.msg);
						}
					}).catch(err => {})
				}else{
					if(type=='stop'){
						this.$message.warning('请选择播放中的视频画面');
					}
				}
			},
			nameClick(data,index){
				if(data.status!=1){
					this.$message.error('设备不在线');
					return false
				}
				let that=this

				if(this.player.length<this.num){
					this.player.push(
						new EZUIKit.EZUIKitPlayer({
							id: 'myPlayer' + this.player.length, // 视频容器ID
							accessToken: this.videoToken, //授权过程获取的access_token
							url: data.url,
							// audio: 1,//是否默认开启声音 1：打开（默认） 0：关闭
							template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
						})
					)
					this.record.push(data)
					this.kzName=this.record!=undefined&&this.record[this.clickIndex]!=undefined&&this.record[this.clickIndex].assetName!=undefined?this.record[this.clickIndex].assetName:"";
				}else{
					if(this.selected){
						this.player[that.clickIndex].stop().then(function() {
							that.player[that.clickIndex].play({
								url:data.url
							})
						})
						this.$set(this.record,that.clickIndex,data)
						this.kzName=this.record!=undefined&&this.record[this.clickIndex]!=undefined&&this.record[this.clickIndex].assetName!=undefined?this.record[this.clickIndex].assetName:"";
					}else{
						this.player[that.videoIndex].stop().then(function() {
							that.player[that.videoIndex].play({
								url:data.url
							})
							if(that.videoIndex<that.num-1){
								that.videoIndex+=1
							}else{
								that.videoIndex=0
							}
						})
						this.$set(this.record,that.videoIndex,data)
						this.kzName=this.record!=undefined&&this.record[this.clickIndex]!=undefined&&this.record[this.clickIndex].assetName!=undefined?this.record[this.clickIndex].assetName:"";
					}
				}
			},



			resetScreenSize(dw, dh) {
				if(window.innerWidth > 1000) {
					function init() {
						var _el = document.getElementById('cloudCenter');
						var hScale = window.innerHeight / (dh || 1080);
						var wScale = window.innerWidth / (dw || 1920);
						_el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
					}
					var lazyFun;
					window.onresize = function() {
						clearTimeout(lazyFun);
						lazyFun = setTimeout(function() {
							init()
						}, 600)
					}
					init()
				}
			}
		},
	}
</script>

<style scoped>
		@import "./index.css";
	#cloudCenter {
		width: 1920px;
		height: 1080px;
		transform-origin: left top;
		position: relative;
	}

	.modular_title {
		display: flex;
		padding: 0 10px 0 20px;
		align-items: center;
		font-size: 22px;
		color: #ffffff;
		line-height: 52px;
	}

	.modular_title div {
		height: 52px;
		display: inline-block;
		background: url(../../assets/tit_bg.png) no-repeat center bottom;
		background-size: 100% 17px;
	}

	.modular_title img {
		margin-right: 9px;
	}

	.video_left {
		float: left;
		margin-left: 30px;
	}

	.pro_video {
		height: 437px;
		width: 452px;
		margin-top: 20px;
		overflow: hidden;
	}
	.pro_video_box {
		height: 357px;
		width: 100%;
		overflow-x: auto;
	}
	.pro_video_box::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}
	.pro_video_box {
		scrollbar-width: none;
		/* firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}
	.project_title {
		display: flex;
		height: 64px;
		line-height: 64px;
		color: #FFFFFF;
		font-size: 14px;
		width: 410px;
		margin: 0 auto;
		border-bottom: 1px solid #56F4FE;
	}

	.project_con_box {
		height: 370px;
		overflow-x: auto;
	}

	.project_con_box::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.project_con_box {
		scrollbar-width: none;
		/* firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.project_content {
		min-height: 51px;
		width: 410px;
		margin: 0 auto;

		font-size: 14px;
		color: #ffffff;

		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
		cursor: pointer;
	}
	.project_list{
		height: 51px;
		display: flex;
		line-height: 51px;
		align-items: center;
	}
	.pro_name {
		text-align: left;
		width: 200px;
	}

	.pro_jr {
		width: 85px;
	}

	.pro_zx {
		width: 85px;
	}
	.pro_zx2 {
		width: 40px;
	}
	.pro_conname {
		width: 200px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: flex;
		align-items: center;
	}

	.pro_conname img {
		width: 14px;
		height: 14px;
		margin-right: 5px;
	}

	.pro_conjr {
		width: 85px;
	}

	.pro_conzx {
		width: 85px;
	}
	.videopaly{
		height: 30px;
		width: 30px;
	}
	.lately_box {
		height: 457px;
		width: 452px;
		margin-top: 10px;

	}

	.search_box {
		position: relative;
		height: 35px;
		width: 412px;
		margin: 0 auto;
		margin-top: 18px;
	}

	.search_box input {
		background: rgba(81, 161, 205, 0.11);
		border-radius: 5px;
		height: 35px;
		width: 392px;
		margin: 0 auto;
		color: #aecbfa;
		font-size: 14px;
		padding-left: 20px;
	}

	.search_box input:focus-visible {
		outline-width: 0px;
	}

	.searchimg {
		position: absolute;
		height: 25px;
		width: 25px;
		top: 5px;
		right: 7px;
		cursor: pointer;
	}

	.lately_probox {
		height: 375px;
		width: 410px;
		margin: 0 auto;
		overflow-x: auto;
		margin-top: 10px;
	}
	.sxzy_box{
		height: 214px;
		width: 214px;
		background: url(../../assets/lrtb_bg.png) no-repeat;
		position: relative;
		clear: both;
		float: left;
		margin-left: 36px;
		margin-bottom: 64px;
	}
	.sxzy_box img{
		position: absolute;
		cursor: pointer;
	}
	.img_left{
		left: 9px;
		top: 96px;
	}
	.img_right{
		right: 9px;
		top: 96px;
	}
	.img_center{
		right: 99px;
		top: 94px;
	}
	.img_top{
		left: 96px;
		top: 9px;
	}
	.img_bottom{
		left: 96px;
		bottom: 9px;
	}
	.lately_probox::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.lately_probox {
		scrollbar-width: none;
		/* firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.kuang2 {
		height: 8px;
		width: 8px;
		margin-right: 20px;
		background: #2e55ff;
	}

	.latelylist {
		height: 51px;
		display: flex;
		align-items: center;
		padding-left: 20px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}

	.latelylist_name {
		width: 300px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #ffffff;
		font-size: 14px;
	}

	.video_right {
		float: right;
		margin-top: 40px;
		width: 1403px;
		height: 867px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		overflow-x: auto;
		margin-right: 20px;
		position: relative;
		overflow: hidden;
	}

	.nextBtn {
		position: absolute;
		z-index: 99;
		top: 20px;
		right: 0;
		cursor: pointer;
	}

	.nextBtn img {
		width: 48px;
		height: 48px;
	}

	.vide_box {
		border: 2px solid #cccccc;
		background: #000000;
		box-sizing: border-box;
		position: relative;
	}
	.vide_box span{
		display: block;
		height: calc(100% - 48px);
		width: 100%;
		position: absolute;
		z-index: 9;
	}
	.clickActive{
		border: 2px solid red;
	}
	.fpzs {
		position: absolute;
		top: 0;
		left: 0;
		color: #FFFFFF;
		display: flex;
	}

	.vide_box>div {
		width: 100%;
		height: 100%;
		overflow: hidden!important;
	}

	.videx {
		height: 50%;
		width: 50%;
		float: left;
	}

	.vide_box::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.vide_box {
		scrollbar-width: none;
		/* firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.video_list {
		width: 457px;
		height: 314.8px;
		margin-right: 10px;
		margin-bottom: 10px;
		text-align: center;
		background: rgba(0, 0, 0, 0.18);
	}

	.video_box {
		width: 422px;
		height: 246px;
		margin: 0 auto;
		margin-top: 12px;
		border-top: 1px solid rgba(0, 0, 0, 0);
	}

	.video_box img {
		width: 400px;
		height: 225px;
		display: block;
		margin: 0 auto;
		margin-top: 10px;
	}

	.video_tit {
		height: 30px;
		width: 418px;
		margin: 0 auto;
		line-height: 30px;
		font-size: 14px;
		color: #FFFFFF;
		margin-top: 10px;
	}
	.video_list_box{
		padding-left: 30px;
	}
	.video_name{
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
	}
	.nameActive{
		background: #085B84;
		color: #00F4FF;
	}
	.fpxz_box{
		float: right;
		margin-top: 24px;
		margin-bottom: 34px;
		margin-left: 28px;
	}
	.fpxz_box img{
		margin-right: 14px;
		cursor: pointer;
	}
	.max_min{
		float: left;
		display: flex;
		flex-direction: column;
		margin-left: 21px;
		margin-top: 41px;
	}
	.max_min div{
		width: 130px;
		height: 51px;
		background: url(../../assets/screen_bg.png) no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
		font-size: 14px;
		color: #FFFFFF;
		cursor: pointer;
	}
	.max_min div img{
		margin-right: 5px;
	}
	.slider_box{
		width: 350px;
		margin: 0 auto;
		clear: both;
		margin-top: 400px;
	}
	.kz_box{
		color: #FFFFFF;
		font-size: 24px;
		float: left;
		margin-top: 22px;
		margin-left: 30px;
	}
	.videotree{
		background: none;
		color: #FFFFFF;
		font-size: 16px!important;
		width: 420px;
    	margin: 0 auto;
    	    height: 365px;
	}
	.videotree div{
		background: none!important;
	}
	/deep/.el-tree-node__content:hover{
		background:none;
	}
	/deep/ .is-current{
		background: none!important;
	}
	/deep/.el-tree-node.is-current > .el-tree-node__content {
	         background: none !important;
	}
	/deep/.el-tree-node:focus>.el-tree-node__content{
		background: none !important;
	}
	/deep/.el-tree-node__content{
		padding-top: 5px;
		padding-bottom: 5px;
	}
	/deep/.treeitem{
		padding-top: 5px;
		padding-bottom: 5px;
	}
</style>
